import type { Attribute } from 'tradera/state/services/types/touchweb-search-api.types';

const ATTRIBUTE_NAMES = {
    BRAND: 'brand',
    CLOTHES_SIZE: 'clothes_size',
    CLOTHES_SIZE_CHILDREN: 'clothes_size_children',
    SHOE_SIZE: 'shoe_size'
};
const ATTRIBUTE_PREFIX = 'af-';

export const getVisibleAttributes = (attributes: Attribute[]) => {
    return attributes
        ?.map(({ name, values }) => {
            switch (name) {
                case ATTRIBUTE_NAMES.BRAND:
                    return { name, values };
                case ATTRIBUTE_NAMES.SHOE_SIZE:
                    return { name, values };
                case ATTRIBUTE_NAMES.CLOTHES_SIZE:
                    return { name: ATTRIBUTE_PREFIX + name, values };
                case ATTRIBUTE_NAMES.CLOTHES_SIZE_CHILDREN:
                    return { name: ATTRIBUTE_PREFIX + name, values };
                default:
                    return null;
            }
        })
        .filter((x) => !!x);
};
